import { Fragment, ReactElement } from 'react';
import ResearchDeathNonResidentNotificationCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-death-non-resident';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchDeathNonResidentNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchDeathNonResidentNotificationCivilStatusShared scope={IdAmbito.Cancellazioni} />
    </Fragment>
  );
};

ResearchDeathNonResidentNotificationCivilStatusPage.displayName =
  'Research Death Non Resident Notifications Page component';

export default ResearchDeathNonResidentNotificationCivilStatusPage;
